var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"user-avatar-modal-wrap"},[_c('div',{staticClass:"user-avatar-modal"},[_c('img',{staticClass:"avatar-icon",attrs:{"src":_vm.imgPath(_vm.user),"width":"350","height":"350","alt":"profile photo"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }